import { useState } from 'react';
import { useRouter } from 'next/router';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import EcoButton from 'eco-design/base/eco-button';

import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
import PartnerModal from '../../pages/product/components/PartnerModal';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import gtm from '@/utils/gtm';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname } = useRouter();
    const { pageStatus } = useProductStore();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const [modalVisible, setModalVisible] = useState(false);

    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
                href: thePageUrl,
            },
        ],
        tabItems: [
            // {
            //     value: 'Product',
            //     label: TextA.tab_product,
            //     href: isInProductPage ? undefined : thePageUrl,
            // },
            // {
            //     value: 'Bundles',
            //     label: TextA.tab_bundles,
            //     href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
            // },
            // {
            //     value: 'Support',
            //     label: TextA.tab_support,
            //     href: `${thePageUrl}/support`,
            // },
            // {
            //     value: 'Specs',
            //     label: TextA.tab_specs,
            //     href: `${thePageUrl}/specs`,
            // },
            // {
            //     value: 'Media',
            //     label: TextA.tab_media,
            //     href: `${thePageUrl}/media`,
            // },
        ],
        buyItems: [
            {
                value: 'Button',
                label: pageStatus === IPageStatus.statusC ? TextA.btn_consultatio : TextA.btn_buy,
                // href: 'https://us.ecoflow.com/',
            },
        ],
    };
    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };

    const handleBuyChange = () => {
        setModalVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Ocean Pro Be the First to Know_Top product navigation',
        });
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={handleBuyChange} />
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
